import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useAttrs, useSlots, watch } from '@nuxtjs/composition-api';
import { useId } from '~/core/composables/useId';

interface Props {
    name?: string,
    placeholder?: string,
    label?: string,
    info?: string,
    error?: string,
    required?: boolean,
    disabled?: boolean,
    showEyeIcon?: boolean,
    size?: 's' | 'm' | 'l',
    inputAttrs?: Record<string, unknown>,
    iconAttrs?: Record<string, unknown>,
    value?: string,
    allowPaste?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordCriteria',
  props: {
    name: null,
    placeholder: null,
    label: null,
    info: null,
    error: null,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    showEyeIcon: { type: Boolean, default: true },
    size: { default: 'm' },
    inputAttrs: null,
    iconAttrs: null,
    value: null,
    allowPaste: { type: Boolean, default: true }
  },
  emits: ['input', 'isPasswordValid'],
  setup(__props: any, { emit: $emit }) {

const props = __props as { name?: string, placeholder?: string, label?: string, info?: string, error?: string, required: boolean, disabled: boolean, showEyeIcon: boolean, size: 's' | 'm' | 'l', inputAttrs?: Record<string, unknown>, iconAttrs?: Record<string, unknown>, value?: string, allowPaste: boolean };





const isTypePassword = ref(true);

const {
    name,
    placeholder,
    label,
    info,
    error,
    required,
    disabled,
    size,
    showEyeIcon,
    inputAttrs,
    value,
    allowPaste,
    iconAttrs,
} = toRefs(props);

const internalValue = ref(value.value);

const hasUppercase = computed(() => /[A-Z]/.test(internalValue.value));
const hasSpecialLetter = computed(() => {
    const specialCharRegex = /[\~\`\!\@\#\$\%\^\&\*\(\)\_\-\+\=\{\[\}\]\|\:\;\"\'\<\,\>\.\?]/;
    return specialCharRegex.test(internalValue.value);
});
const hasNumber = computed(() => {
    const numberRegex = /\d/;
    return numberRegex.test(internalValue.value);
});
const hasMinLength = computed(() => {
    return internalValue.value.length >= 8 && internalValue.value.length <= 24;
});
const isPasswordValid = computed(() => {
    return hasUppercase.value && hasSpecialLetter.value && hasNumber.value && hasMinLength.value;
})

const preventSpace = (event: KeyboardEvent) => {
    if (event.key === ' ') {
        event.preventDefault();
    }
}

watch(internalValue, (newValue) => {
    if (newValue !== value.value)
        $emit('input', newValue);
});
watch(value, (newValue) => {
    if (newValue !== internalValue.value)
        internalValue.value = newValue;
});
watch(isPasswordValid, (newValue) => {
    $emit('isPasswordValid', newValue);
});

const id = useId();
const componentId = computed(() => {
    const attrs = useAttrs();
    return attrs.id ? String(attrs.id) : id;
});
const errorId = computed(() => error.value || useSlots()['error-text'] ? componentId.value + '_error' : undefined);

return { __sfc: true,$emit, props, isTypePassword, name, placeholder, label, info, error, required, disabled, size, showEyeIcon, inputAttrs, value, allowPaste, iconAttrs, internalValue, hasUppercase, hasSpecialLetter, hasNumber, hasMinLength, isPasswordValid, preventSpace, id, componentId, errorId }
}

})